import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface AgentUserActorSaveResponse {
  message: string;
};

// 请求接口
interface AgentUsersCreateRequest {
  actorId: string;
  actorName: string;
  voiceName: string;
  voiceId?: string;
  voiceUrl?: string;
}


export class AgentUserCreateData {
  // @Required("message cannot be empty")
  @IsString("message must be a string")
  message: string;
}

const transformAndValidateAgent = (
  response: AgentUserActorSaveResponse
): AgentUserCreateData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AgentUserCreateData);
  } catch (error) {
    console.error("Agent User Actor data validation failed:", error.message);
    throw error;
  }
};

/** 保存视频信息 */
export const agentUserSaveActorInfo = async ({ actorId, actorName, voiceId, voiceName, voiceUrl }: AgentUsersCreateRequest): Promise<AgentUserCreateData> => {
  const response = await api.post<AgentUserActorSaveResponse>('/agent/user/save-actor-info', {
    actor_id: actorId,
    actor_name: actorName,
    voice_id: voiceId,
    voice_name: voiceName,
    voice_url: voiceUrl,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
